<template>
  <div class="admin-container">
    <!-- 主体区域 -->
    <el-container class="main-container">
      <!-- 左侧组件库 -->
      <el-aside width="15vw" class="components-panel">
        <div class="panel-title">组件库</div>
        <div class="components-list">
          <draggable
            :list="components"
            :group="{ name: 'components', pull: 'clone', put: false }"
            :sort="false"
            :clone="deepClone"
            item-key="id"
            @end="onDragEnd"
            class="components-list"
          >
            <transition-group name="list" tag="div">
              <div
                v-for="element in components"
                :key="element.localId"
                class="component-item"
              >
                <i :class="element.icon"></i>
                <span>{{ element.name }}</span>
              </div>
            </transition-group>
          </draggable>
        </div>
      </el-aside>

      <!-- 中间编辑区域 -->
      <el-main class="editor-container">
        <div class="canvas-title">页面编辑区</div>
        <div class="canvas-wrapper">

          <van-tabs v-model="activeName" @change="tabsChange">
            <van-tab v-for="(category,index) in categoryOptions" :key="index" :title="category.value" :name="category.value">
              <draggable
                v-model="wholeLayout[index]"
                group="components"
                item-key="id"
                @drag="onDragEnd"
                @choose="onDragChoose"
                class="draggable-container"
              >
                <transition-group name="list" tag="div">
                  <div
                    v-for="(element, index) in wholeLayout[index]"
                    :key="element.localId"
                    class="component-wrapper"
                  >
                    <component
                      :is="element.componentName"
                      :config="element.config"
                      :category="activeName"
                      @config-change="updateConfig(index, $event)"
                    />
                    <div class="component-actions">
                      <i class="el-icon-delete" @click="deleteComponent(index)"></i>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </van-tab>
          </van-tabs>
        </div>
        <div class="canvas-bottom">
          <el-button type="primary" @click="refresh">保存并刷新</el-button>
        </div>
      </el-main>

      <!-- 右侧配置区域 -->
      <el-aside width="20vw" class="config-panel" >
        <component-config
          v-if="activeComponent"
          :config="activeComponent"
          :category="activeName"
          :sortIndex="activeIndex"
          :needDelImages="needDelImages"
          @update="updateActiveConfig"
          @update-media="handleMediaUpdate"
        />
      </el-aside>
    </el-container>

  </div>
</template>

<script>

// 导入组件
import BannerComponent from '@/components/instrument/BannerComponent.vue'
import GoodsList from '@/components/instrument/GoodsList.vue'
import ComponentConfig from '@/components/instrument/ComponentConfig.vue'
import HotSearchComponent from "@/components/instrument/HotSearchComponent.vue";
import CouponComponent from "@/components/instrument/CouponComponent.vue";
import axios from "axios";

export default {
  name: 'DecorationPage',
  components: {
    BannerComponent,
    GoodsList,
    ComponentConfig,
    HotSearchComponent,
    CouponComponent
  },
  data() {
    return {
      components: [{
        localId: '1',
        name: '轮播图',
        icon: 'el-icon-picture',
        componentName: 'BannerComponent',
        config: {
          moduleName: '',
          listType: 'width',
          mediaUrls: [{ mediaUrl: '',  productId: '',productName: '',mediaType: '' ,mediaFile: ''}],
          interval: 3000
        },
      },{
        localId: '2',
        name: '商品列表',
        icon: 'el-icon-s-grid',
        componentName: 'GoodsList',
        config: {
          moduleName: '',
          columns: 2,
          listType: 'normal',
          goods: [{tabName: '',tabData: []}]
        },
      },{
        localId: '3',
        name: '优惠券',
        icon: 'el-icon-document-copy',
        componentName: 'CouponComponent',
        config: {
          moduleName: '',
          couponList: [{couponInfo: {couponName: '',couponPrice: '',usePrice: 0,categoryLimit: '1',}}]
        },
      },{
        localId: '4',
        name: '热词库',
        icon: 'el-icon-document',
        componentName: 'HotSearchComponent',
        config: {
          moduleName: '',
          hotWords: []
        },
      }],

      showEditDialog: false,
      editingIndex: null,
      carousel: [],


      activeIndex: null, //选择的单一组件数组下标
      activeComponent: null, //选择的组件对象

      //大类菜单栏
      categoryOptions: [],
      activeName: '',
      wholeLayout: [], //所有大类布局的数组
      needDelImages: [], //所需删除的图片
    }
  },
  async mounted(){
    await this.getCategories();
    await this.init();
  },
  methods: {
    // 深拷贝函数（生成新地址，生成新ID）
    deepClone(item) {
      const newItem = JSON.parse(JSON.stringify(item)); // 基础深拷贝
      newItem.localId = newItem.componentName + Date.now() + (Math.floor(Math.random() * 100) + 1);
      return newItem
    },

    //获取线上模板同步线下
    async init(){
      const carousels = await this.$request.get_message('carousels',{});

      carousels.data.forEach((carousel,index) => {
        let temp_layout = this.buildData(carousel)

        this.categoryOptions.forEach((category,idx) => {
          if(carousel.category === category.value){
            this.wholeLayout[idx].push(temp_layout)
          }
        })
      })
    },

    reset(){
      this.wholeLayout = []
      this.activeComponent = null;
      this.activeIndex = null;
    },

    buildData(carousel){
      let temp_layout = {}
      if(carousel.moduleType === 'swiper'){
        carousel.mediaUrls.forEach( con => {
          const ext = con.mediaUrl.split('.')[1];
          let mt
          if(/jpg|png/.test(ext)) mt = 'image';
          else mt = 'video';
          con.mediaUrl = con.mediaUrl ? `${this.$config.product_image_url}index_image/${con.mediaUrl}` : '';
          con.productId = con.productInfo ? con.productInfo._id : '';
          con.productName = con.productInfo ? con.productInfo.name : '';
          con.mediaType = mt;
          con.mediaFile = '';
        })
        temp_layout = {
          name: '轮播图',
          icon: 'el-icon-picture',
          componentName: 'BannerComponent',
          config: {
            carouselId: carousel._id,
            mediaUrls: carousel.mediaUrls,
            moduleName: carousel.moduleName,
            interval: carousel.interval,
            listType: carousel.listType,
          },
        }
      }else if(carousel.moduleType === 'goodsList'){
        temp_layout ={
          name: '常规商品列表',
          icon: 'el-icon-s-grid',
          componentName: 'GoodsList',
          config: {
            carouselId: carousel._id,
            moduleName: carousel.moduleName,
            columns: carousel.arrange,
            listType: carousel.listType,
            goods: carousel.goods,
          },
        }
      }else if(carousel.moduleType === 'hotSearch'){
        temp_layout ={
          name: '热词库',
          icon: 'el-icon-document',
          componentName: 'HotSearchComponent',
          config: {
            carouselId: carousel._id,
            moduleName: carousel.moduleName,
            hotWords: carousel.hotWords || []
          },
        }
      }else if(carousel.moduleType === 'coupon'){
        temp_layout ={
          name: '优惠券',
          icon: 'el-icon-document-copy',
          componentName: 'CouponComponent',
          config: {
            carouselId: carousel._id,
            moduleName: carousel.moduleName,
            couponList: carousel.couponList || [{
              couponInfo: {
                couponName: '',
                couponPrice: '',
                usePrice: 0,
                categoryLimit: '1',
              }
            }]
          },
        }
      }
      temp_layout.localId = carousel.moduleType + Date.now() + (Math.floor(Math.random() * 100) + 1);
      return temp_layout
    },

    onDragEnd(evt) {
      this.activeIndex = evt.newIndex
    },

    onDragChoose(evt){
      this.activeIndex = evt.oldIndex;

      // 直接引用数组中的元素（非拷贝）
      let targetArray = []
      this.categoryOptions.forEach((category,index) => {
        if(this.activeName === category.value){
          targetArray = this.wholeLayout[index]
        }
      })
      if(targetArray.length > 0){
        this.activeComponent = targetArray[this.activeIndex]; // 关键：直接指向原数组元素
      }
    },

    deleteComponent(index) {
      this.$dialog.confirm({
        message: '是否删除该模板',
      })
        .then(async () => {
          let thisLayout = [];
          this.categoryOptions.forEach((category,idx) => {
            if(this.activeName === category.value){
              thisLayout = this.wholeLayout[idx]
            }
          })

          if(thisLayout.length > 0){
            if(thisLayout[index].config.carouselId){
              if(thisLayout[index].componentName === 'BannerComponent'){
                const files = thisLayout[index].config.mediaUrls;
                let urls = [];
                files.forEach(file => {
                  const temp = file.mediaUrl.split("/")
                  urls.push(`product/index_image/${temp[temp.length - 1]}`);
                })
                //console.log(urls);
                if(urls.length !== 0) await this.dropFile(urls);
              }

              const result = await this.$request.delete_message('carousels',thisLayout[index].config.carouselId)
              if(result.code === 0){
                this.$message('信息删除成功');
                thisLayout.splice(index,1);
              }else{
                this.$message('信息删除失败！');
              }
            }else{
              thisLayout.splice(index,1);
            }
          }
        })
        .catch(() => {
          // on cancel
        })
        .finally(() => {
          this.activeComponent = null;
          this.activeIndex = null;
        })
    },

    //请求执行删除
    async dropFile(urls){
      let result = await this.$request.drop_files(urls);
      if(result.code === 0)
        this.$message('文件删除成功!');
      else
        this.$message('文件删除异常!');
    },

    async updateActiveConfig(config) {
      await this.resetSortIndexAndLocalData(config);
    },

    //更新线上排序同时更新本地数据
    async resetSortIndexAndLocalData(updateOrigin){
      //console.log(updateOrigin)
      let sortList = [];
      this.categoryOptions.forEach((category,idx) => {
        if(updateOrigin.category === category.value){
          sortList = this.wholeLayout[idx];
        }
      })
      if(sortList.length > 0){
        this.activeComponent.config.carouselId = updateOrigin._id;

        const sortArray = sortList.map((sortData,index) => {
          //为确保最准确的找到该模板并同步线上数据，不可使用this.activeIndex,该参数可能在进行组件顺序移动时变得不可靠，只能通过this.activeComponent中的值与该数组中的值对应确定为需要同步数据的对象
          if(this.activeComponent.config.carouselId === sortData.config.carouselId){
            //console.log(this.buildData(updateOrigin),sortData)
            //sortList[index] = this.buildData(updateOrigin);
            if(updateOrigin.moduleType === 'swiper'){
              sortList[index].config.mediaUrls.forEach((mediaUrl,idx) => {
                mediaUrl.mediaUrl = `${this.$config.product_image_url}index_image/${updateOrigin.mediaUrls[idx].mediaUrl}`
              })
            }
            this.activeComponent =sortList[index];
          }
          return {
            '_id': sortData.config.carouselId,
            'sortIndex': (index + 1)
          }
        })
        //console.log('sortArray',sortArray)
        const sortResult = await this.$request.update_sort_index(sortArray);
        //console.log(sortResult);
        if(sortResult.code === 0){
          this.$message(sortResult.data.message)
        }
      }
    },

    updateConfig(index, config) {
      this.categoryOptions.forEach((category,idx) => {
        if(this.activeName === category.value){
          this.wholeLayout[idx][index].config = config
        }
      })
    },

    preview() {
      // 在小程序中预览逻辑
      this.$message.info('打开小程序预览页面')
    },

    async getCategories(){
      const categories = await this.$request.get_message('categories',{});
      const categoryOptions = [];
      const wholeLayout = [];

      if(categories.code === 0){
        categories.data.forEach(category => {
          categoryOptions.push({
            value: category.categoryName
          })
          wholeLayout.push([])
        })
        this.activeName = categoryOptions[0].value
        this.categoryOptions = categoryOptions;
        this.wholeLayout = wholeLayout;
      }else{
        this.$message(categories['errMsg'])
      }
    },

    tabsChange(){
      this.activeComponent = null;
      this.activeIndex = null;
    },

    handleMediaUpdate(payload){
      this.activeComponent.config.mediaUrls[payload.index].mediaUrl = payload.mediaUrl
      this.activeComponent.config.mediaUrls[payload.index].mediaFile = payload.mediaFile
      this.activeComponent.config.mediaUrls[payload.index].mediaType = payload.mediaType
    },

    refresh(){
      this.$dialog.confirm({
        message: '是否保存所有模板',
      }).then(async ()=>{
        const all_layout = this.wholeLayout;
        const toKey = {
          'BannerComponent': 'swiper',
          'GoodsList': 'goodsList',
          'HotSearchComponent': 'hotSearch',
          'CouponComponent' :'coupon'
        }
        let errorMsg = '';
        const sortArray = [];
        for(let [index,categoryLayout] of all_layout.entries()){
          const category = this.categoryOptions[index].value;
          for(let [i,data] of categoryLayout.entries()){
            const type = toKey[data.componentName];
            const oneRes = await this.handleSubmit(type,category,data.config);
            if(oneRes.code === 0){
              data = this.buildData(oneRes.data);
              sortArray.push({
                '_id': data.config.carouselId,
                'sortIndex': (i + 1)
              })
            }else{
              errorMsg += `${category}下第${i + 1}个模板保存失败;`
            }
          }
          const sortResult = await this.$request.update_sort_index(sortArray);
          // if(sortResult.code === 0){
          //   this.$message(sortResult.data.message)
          // }
        }
        if(errorMsg) this.$message('执行保存完成，' + errorMsg);
        else this.$message('执行保存完成');

      })
    },

    //提交保存
    async handleSubmit(type,category,submitData){
      //console.log(type);
      this.submitting = true;
      try {
        let options = {
          moduleName: submitData.moduleName,
          moduleType: type,
          category,
        };

        if(type === 'coupon'){ //优惠券参数
          options.couponList = submitData.couponList.map(coupon => {
            return {
              couponId: coupon.couponInfo._id,
            }
          })
        }else if(type === 'hotWords'){ //热词参数
          options.hotWords = submitData.hotWords || []
        }else if(type === 'goodsList'){ //商品列表参数
          const _goods = [];
          for (const item of submitData.goods) {
            let temp = {
              tabName: item.tabName,
              tabData: [],
            }
            if(submitData.listType === 'calendar' && item.isNewDate) temp.isNewDate = true;
            item.tabData.forEach(data => {
              if(data.productInfo){
                temp.tabData.push({
                  productId: data.productInfo._id
                })
              }
            })
            _goods.push(temp);
          }

          options.listType = submitData.listType || 'normal';
          options.arrange = submitData.columns || 2;
          options.goods = _goods;
        }else if(type === 'swiper'){
          // 2. 先上传所有媒体文件到服务器
          const formData = new FormData();
          submitData.mediaUrls.forEach(item => {
            // 如果是本地文件需要上传
            if(item.mediaFile) formData.append('uploadFiles',item.mediaFile)
          });

          const uploadResponse = await this.$request.file_upload('indexImage',formData);

          const uploadedUrls = uploadResponse.data;

          // 3. 更新轮播图项的URL为服务器URL
          let urlIndex = 0;
          const itemsForSaving = submitData.mediaUrls.map(item => {
            if(item.mediaFile)
              return {
                productId: item.productId,
                mediaUrl: uploadedUrls[urlIndex++].filename
              }
            else{
              const i = item.mediaUrl.split('/');
              return {
                productId: item.productId,
                mediaUrl: i[i.length - 1]
              }
            }
          });

          options.listType = submitData.listType || 'width';
          options.interval = submitData.interval || 3000;
          options.mediaUrls = itemsForSaving

        }

        if(submitData.carouselId) options.id = submitData.carouselId;
        const newCarousel = await this.$request.set_message('carousels',options);

        if(type === 'swiper'){
          await this.$request.drop_files(this.needDelImages);
          this.needDelImages.splice(0,this.needDelImages.length);
        }

        return newCarousel;
      }catch (e){
        console.error(e);
        // if (e.response) {
        //   this.$message.error(`保存失败: ${e.response.data.message || '服务器错误'}`);
        // } else {
        //   this.$message.error('保存失败: 网络错误或服务器异常');
        // }
      } finally {
        this.submitting = false;
      }
    },

  }
}
</script>

<style scoped>
.admin-container {
  height: 90vh;
  display: flex;
  flex-direction: column;
}

.header {
  background: #409EFF;
  color: white;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
}

.main-container {
  flex: 1;
  overflow: hidden;
}

.components-panel, .config-panel {
  padding: 0 15px;
  border: 1px solid #EBEEF5;
  background: #f8f8f8;
  overflow-y: auto;
}

.panel-title, .canvas-title {
  padding: 12px 15px;
  font-weight: bold;
  border-bottom: 1px solid #EBEEF5;
}

.canvas-bottom{
  margin-top: 15px;
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
}

.components-list {
  padding: 10px;
}

.component-item {
  padding: 12px 15px;
  margin-bottom: 8px;
  background: white;
  border-radius: 4px;
  border: 1px dashed #DCDFE6;
  cursor: move;
  transition: all 0.3s;
}

.component-item:hover {
  border-color: #409EFF;
  color: #409EFF;
}

.component-item i {
  margin-right: 8px;
}

.editor-container {
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
  padding-top: 0;
  align-items: center;
  justify-content: space-between;
}

.canvas-wrapper {
  border-radius: 15px;
  height: 700px;
  width: 360px;
  padding: 20px;
  overflow-y: auto;
  background: white;
  border: 1px solid #EBEEF5;
  margin: 0 10px;
}

.draggable-container {
  height: 600px;
  margin-top: 10px;
}

.draggable-container>div{
  height: 100%;
}

.component-wrapper {
  position: relative;
  margin-bottom: 20px;
  border: 1px dashed #ddd;
  padding: 15px;
  border-radius: 4px;
  transition: all 0.3s;
}

.component-wrapper:hover {
  border-color: #409EFF;
}

.component-actions {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(255,255,255,0.8);
  padding: 5px;
  border-radius: 4px;
}

.component-actions i {
  margin-left: 8px;
  cursor: pointer;
  color: #606266;
}

.component-actions i:hover {
  color: #409EFF;
}

.tab-content{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Decoration.vue